import $ from 'jquery';
import { Functions } from '../helpers';

export class Menu {

	constructor( App ) {
		Menu.App                    = App;
		Menu.UI                     = App.PwnUI;
		Menu.settings               = App.settings;
		Menu.$navigation            = $( '.js-pwn-main-navigation' );
		Menu.$navigationToggle      = $( '.js-pwn-toggle-navigation' );
		Menu.$navigationCloseToggle = $( '.js-pwn-close-toggle-navigation' );
		Menu.superfish              = null;
		this.initialize();
	};

	initialize() {
		Menu.$navigationToggle.on( 'click', function( e ) {
			Functions.killEvent( e );

			if ( ! Menu.UI.$body.hasClass( 'menu-shown' ) ) {
				Menu.UI.$body.addClass( 'menu-shown' );
			}
		} );

		Menu.$navigationCloseToggle.on( 'click', function( e ) {
			Functions.killEvent( e );

			if ( Menu.UI.$body.hasClass( 'menu-shown' ) ) {
				Menu.UI.$body.removeClass( 'menu-shown' );
			}
		} );

		Menu.UI.$document.off( 'click.bs.dropdown.data-api', '[data-toggle="dropdown"]' );

		Menu.resize();
	};

	static resize() {
		var $navigationDropdownToggle = Menu.$navigation.find( '[data-toggle="dropdown"]' );

		if ( Menu.UI.viewportWidth < 992 ) {
			$navigationDropdownToggle.off( 'click.bs.dropdown' ).on( 'click.bs.dropdown', function( e ) {
				Functions.killEvent( e );

				var $this = $( this );

				if ( $this.is( '.disabled, :disabled' ) ) return;

				var $parent  = $this.parent();
				var isActive = $parent.hasClass( 'open' );
				var selector = $this.attr( 'href' );

				selector = selector && /#[A-Za-z]/.test( selector ) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7

				if ( isActive && ! selector ) {
					location.href = $this.attr( 'href' );

					return false;
				}

				var relatedTarget = { relatedTarget: this }

				if ( ! isActive ) {
					$parent.trigger( e = $.Event( 'show.bs.dropdown', relatedTarget ) );
					// $parent.find( '> .dropdown-menu' ).stop( true, true ).slideDown( '350' );

					$this
						.trigger('focus')
						.attr('aria-expanded', 'true')

					$parent
						.addClass('open')
						.trigger($.Event('shown.bs.dropdown', relatedTarget))
				}
				else {
					$parent.trigger( e = $.Event( 'hide.bs.dropdown', relatedTarget ) );
					// $parent.find( '> .dropdown-menu' ).stop( true, true ).slideUp( '350' );
					$this.attr( 'aria-expanded', 'false' );
					$parent.removeClass( 'open' ).trigger( $.Event('hidden.bs.dropdown', relatedTarget ) );
				}

				return false;
			} );
		}
		else {
			$navigationDropdownToggle.off( 'click.bs.dropdown' );
		}
	};
}
